import { DataType, FormatHint } from '../../types';
import { ColumnType, DataCell } from '@ecosystem/export-api';

export const mapValueToDataCell = (
  value: number | string | null,
  formatHint?: FormatHint,
  dataType?: DataType
): DataCell => {
  if (value === null || value === undefined) {
    return {
      type: ColumnType.Text,
      value: '-',
    };
  }

  const defaultFormat = {
    type: typeof value === 'number' ? ColumnType.Number : ColumnType.Text,
    value: value,
  };
  if (formatHint) {
    switch (formatHint) {
      case FormatHint.Money:
        return {
          type: ColumnType.Currency,
          value: value,
        };
      case FormatHint.Percentage:
        return {
          type: ColumnType.Percentage,
          customFormat: '0.0%',
          value: value,
        };
      case FormatHint.PercentagePoints:
        return {
          type: ColumnType.PercentagePoint,
          customFormat: '0.00"pp"',
          value: (value as number) * 100,
        };
      default:
        return defaultFormat;
    }
  } else {
    switch (dataType) {
      case DataType.Integer:
        return {
          type: ColumnType.Number,
          customFormat: '#,##0',
          value: value,
        };
      case DataType.Decimal:
        return {
          type: ColumnType.Number,
          customFormat: '0.00',
          value: value,
        };
      default:
        return defaultFormat;
    }
  }
};
